import type React from 'react';
import { useContext, useEffect, useRef } from 'react';
import TagManager from 'react-gtm-module';

import constants from './../../constants';
import { CookiebotContext } from '../../state/CookiebotContextProvider';
import { isFeatureEnabled } from '../../utils/feature';

const tagManagerArgs = {
	gtmId: constants.gtmId,
};

const GoogleTagManager: React.FC = () => {
	const consent = useContext(CookiebotContext);
	// Initializing injects the container script — guard it to once per mount so
	// context re-renders don't re-inject it.
	const initializedRef = useRef(false);

	useEffect(() => {
		if (initializedRef.current || !isFeatureEnabled('googleAnalytics') || !consent.statistics) return;
		initializedRef.current = true;
		TagManager.initialize(tagManagerArgs);
	}, [consent.statistics]);

	return null;
};

export default GoogleTagManager;
